module.exports = __webpack_public_path__ + "static/media/web-sign-in-bg.2c250a78.png";